var map = {
	"./de/triangle-icon.png": "3E4t",
	"./en/triangle-icon.png": "6F42",
	"./es/triangle-icon.png": "dfwq",
	"./fr/triangle-icon.png": "KJ2O",
	"./ja/triangle-icon.png": "wQey",
	"./ko/triangle-icon.png": "kiPZ",
	"./pt/triangle-icon.png": "znQO",
	"./ru/triangle-icon.png": "a0ct",
	"./tc/triangle-icon.png": "eB1f",
	"./th/triangle-icon.png": "LR6m"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "B8ix";